<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="Aaf"><section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Other Books by H. Jackson Brown, Jr."><h1 class="ct_1" id="pz4-1">Other Books by H. Jackson Brown, Jr. </h1>
<p class="noind1"><em>A Father’s Book of Wisdom</em></p>
<p class="noind1" id="pz6-3"><em>P.S. I Love You</em></p>
<p class="noind1" id="pz6-4"><em>Life’s Little Instruction Book™</em> <br/> (volumes I, II, and III)</p>
<p class="noind1" id="pz6-6"><em>Live and Learn and Pass It On</em> <br/> (volumes I, II, and III)</p>
<p class="noind1" id="pz6-8"><em>Wit and Wisdom from the Peanut Butter Gang</em></p>
<p class="noind1" id="pz6-9"><em>The Little Book of Christmas Joys</em> <br/> (with Rosemary C. Brown and Kathy Peel)</p>
<p class="noind1" id="pz6-11"><em>A Hero in Every Heart</em> <br/> (with Robyn Spizman)</p>
<p class="noind1" id="pz6-13"><em>Life’s Little Treasure Books</em> <br/> On Marriage and Family, On Wisdom, On Joy, On Success, On Love, On Parenting,<br/> Of Christmas Memories, Of Christmas Traditions, On Hope, On Friendship,<br/> On Fathers, On Mothers, On Things That Really Matter, On Simple Pleasures</p>
<p class="noind1" id="pz6-17"><em>Kids’ Little Treasure Books</em> <br/> On Happy Families, On What We’ve Learned . . . So Far</p>
<p class="noind1" id="pz6-19"><em>Life’s Little Instructions from the Bible</em> <br/> (with Rosemary C. Brown)</p>
<p class="noind1" id="pz6-21"><em>Life’s Little Instruction Book™ from Mothers to Daughters</em> <br/> (with Kim Shea)</p>
<p class="noind1" id="ARm"><em>Life’s Little Instruction Book™ for Incurable Romantics</em> <br/> (with Robyn Spizman)</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter02.vue?1469c513